import { render, staticRenderFns } from "./Spiner.vue?vue&type=template&id=4e10ef2a&scoped=true"
import script from "./Spiner.vue?vue&type=script&lang=js"
export * from "./Spiner.vue?vue&type=script&lang=js"
import style0 from "./Spiner.vue?vue&type=style&index=0&id=4e10ef2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e10ef2a",
  null
  
)

export default component.exports